// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --es-row-col-max-width: 100%;
  --es-container-padding: 0 15px;
  --es-container-border: none;
  --es-first-col-auto-order: 0;
  --es-dropdown-search-result-open-mt: 15px;
  --es-dropdown-search-result-open-position: absolute;
  --es-dropdown-search-result-open-top: 100%;
  --es-dropdown-search-result-open-width: auto;
  --es-dropdown-search-result-open-overflow: auto;
}
:host .error {
  color: red;
  font-size: 14px;
}
:host .container-fluid {
  padding: var(--es-container-padding);
  border: var(--es-container-border);
}
:host .row .col {
  max-width: var(--es-row-col-max-width);
}
:host .row .col-auto:first-child {
  order: var(--es-first-col-auto-order);
}
:host .event-input-wrapper {
  position: relative;
}
:host .event-input-wrapper .dropdown-menu.dropdown-search-result.open {
  margin-top: 0;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
}
:host .event-search-spinner {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
:host .dropdown-menu.dropdown-search-result.open {
  margin-top: var(--es-dropdown-search-result-open-mt);
  position: var(--es-dropdown-search-result-open-position);
  top: var(--es-dropdown-search-result-open-top);
  width: var(--es-dropdown-search-result-open-width);
  overflow: var(--es-dropdown-search-result-open-overflow);
}
:host .ev-selection-row {
  display: flex;
}
@media screen and (max-width: 450px) {
  :host .ev-selection-row {
    flex-direction: column;
  }
}
@media screen and (max-width: 450px) {
  :host .event-thumbnail {
    display: flex;
    justify-content: center;
  }
}
@media screen and (max-width: 450px) {
  :host .btn-close {
    position: absolute;
    top: 0;
    right: 20px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
